export default "__VITE_ASSET__CWrYZqF2__"